/*=========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
==========================================================================================*/

import axios from "@/axios.js";
import store from "@/store/store.js";

export default {

  setEmailList({ commit }, email) {
    return new Promise((resolve, reject) => {
      commit("ADD_TO_ENDORSEMENT_INVITE_EMAIL_LIST", email);
      resolve(email);
    });
  },

  removeEmailList({ commit }, email) {
    return new Promise((resolve, reject) => {
      commit("REMOVE_FROM_ENDORSEMENT_INVITE_EMAIL_LIST", email);
      resolve(email);
    });
  },

  /*getAllProgressMeasures({ commit }) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("progress-measure-list/find")
        .then(res => {
          resolve(res.data);
        })
        .catch(err => reject(err));
    });
  },*/

  addProgressMeasure({ commit }, progressMeasure) {
    return new Promise((resolve, reject) => {
      commit("ADD_PROGRESS_MEASURE", progressMeasure);
      resolve(progressMeasure);
      return progressMeasure; // resolve(td)
    });
  },

  removeProgressMeasure({ commit }, progressMeasure) {
    return new Promise((resolve, reject) => {
      commit("REMOVE_PROGRESS_MEASURE", progressMeasure);
      resolve(progressMeasure);
      return progressMeasure; // resolve(td)
    });
  },

  sendEndorsementInvite({ commit }, endorsementInvite) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("endorsement-invite/create", endorsementInvite)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          console.log("error sending Endorsement Invite", err);
          reject(err);
        });
    });
  },

  sendEndorsementInvitePrgms({commit}, progressMeasure) {
    return new Promise((resolve, reject) => {
      store.dispatch("endorsement-invite-prgms/create", progressMeasure).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("error sending endo invite prgms", err);
        reject(err);
      });
    });
  },

  addExternalFeedback({commit}, gapObj) {
    return new Promise((resolve, reject) => {
      const currentGap = gapObj.currentGap;
      const currentGapText = gapObj.currentGapText;
      const index = gapObj.index;
      commit("ADD_EXTERNAL_FEEDBACK", gapObj)
      resolve(gapObj)
    });
  },

  pushExternalFeedback({commit}, extFeedObj) {
    return new Promise((resolve, reject) => {
      store.dispatch("external-feedback/create", extFeedObj).then(res => {
        resolve(res)
      }).catch(err => {
        console.log("error pushing external feedbacks", err);
      })
    })
  },

  sendEmails({commit}, extFeedObj) {
    return new Promise((resolve, reject) => {
      store.dispatch("invitee-message-id/create", extFeedObj).then(res => {
        resolve(res)
      }).catch(err => {
        console.log("error pushing send email", err);
      })
    })
  },

  fetchExtFeeds({commit}, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("external-feedback/find", query).then(res => {
        resolve(res)
      }).catch(err => {
        console.log("error finding external-feedback data", err);
        reject(err)
      })
    })
  },

  fetchPrgms({commit}, id) {
    return new Promise((resolve, reject) => {
      store.dispatch("endorsement-invite-prgms/get", id).then(res => {
        resolve(res)
      }).catch(err => {
        console.log("error finding endo invite prgms data", err);
        reject(err)
      })
    })
  },

  // saveExternalFeedback({commit}, gapFeed) {
  //   return new Promise((resolve, reject) => {
  //     let currentGapSum=0;
  //     for(let j=0;j<gapFeed.length;j++) {
  //       currentGapSum = currentGapSum +gapFeed[j].currentGap;
  //     }
  //     if(currentGapSum===0){
  //       for(let j=0;j<gapFeed.length;j++) {
  //         store.dispatch("external-feedback/find", {
  //           query: {id: gapFeed[j].extId}
  //         }).then(res => {
  //           store.dispatch("external-feedback/find", {
  //             query: {
  //               endorsementInvitePrgmsId: res.data[0].endorsementInvitePrgmsId,
  //             }
  //           }).then(response => {
  //             let deletedexternalToken = [];
  //             for (var i = 1; i < response.data.length; i++) {
  //               deletedexternalToken.push(response.data[i].externalToken);
  //             }
  //             store.dispatch("invitee-message-id/find", {
  //               query: {
  //                 externalToken: deletedexternalToken
  //               }
  //             }).then(res1 => {
  //               let gapFeedObj = {};
  //               if ((response.data.length) === 1) {
  //                 gapFeedObj = {
  //                   currentGap: 0,
  //                   feedbackReceivedDate:new Date(new Date().setDate(new Date().getDate() + 1)),
  //                   externalTokenExpired: 1,
  //                   index: gapFeed[j].index,
  //                   emailStatus: 4,
  //                   notesDescription:gapFeed[j].notesDescription,
  //                   flag: 'noGap',
  //                   feedbackId: gapFeed[j].extId,
  //                   messageId: res1.data
  //                 }
  //               } else {
  //                 gapFeedObj = {
  //                   currentGap:0,
  //                   feedbackReceivedDate:new Date(new Date().setDate(new Date().getDate() + 2)),
  //                   flag: 'noGap',
  //                   index: gapFeed[j].index,
  //                   emailStatus: 4,
  //                   notesDescription:gapFeed[j].notesDescription,
  //                   externalTokenExpired: 1,
  //                   feedbackId: gapFeed[j].extId,
  //                   messageId: res1.data
  //                 }
  //               }
  //               store.dispatch("external-feedback/patch", [gapFeed[j].extId, gapFeedObj]).then(res1 => {
  //                 store.dispatch("external-feedback/find", {
  //                   query: {
  //                     endorsementInvitePrgmsId: res1.endorsementInvitePrgmsId,
  //                     currentGap: null
  //                   }
  //                 }).then(res => {
  //                   for (var i = 0; i < res.data.length; i++) {
  //                     //  const date = new Date();
  //                     if ((new Date(res.data[i].feedbackSentDate)) >(new Date())) {
  //                       let ZeroGapDataAll={};
  //                       if(res.data.length<=5) {
  //                         ZeroGapDataAll = {
  //                           currentGap: 0,
  //                           feedbackStatus: i,
  //                           emailStatus: 5,
  //                           notesDescription:gapFeed[i].notesDescription,
  //                           externalTokenExpired: 1,
  //                           feedbackReceivedDate: new Date(new Date().setDate(new Date().getDate() + 2))
  //                         }
  //                       }
  //                       else{
  //                         ZeroGapDataAll = {
  //                           currentGap: 0,
  //                           feedbackStatus: i,
  //                           emailStatus: 5,
  //                           notesDescription:gapFeed[i].notesDescription,
  //                           externalTokenExpired: 1,
  //                           feedbackReceivedDate: new Date(new Date().setDate(new Date().getDate() + 1))
  //                         }
  //                       }
  //                       store.dispatch("external-feedback/patch", [res.data[i].id, ZeroGapDataAll]).then(res => {
  //                         resolve(res)
  //                       }).catch(err => {
  //                         console.log("could not save ext feed", err)
  //                         reject(err)
  //                       })
  //                     }
  //                     else{
  //                       const ZeroGapData = {
  //                         externalTokenExpired: 1,
  //                       }
  //                       store.dispatch("external-feedback/patch", [res.data[i].id, ZeroGapData]).then(res => {
  //                         resolve(res)
  //                       }).catch(err => {
  //                         console.log("could not save ext feed", err)
  //                         reject(err)
  //                       })
  //                     }
  //                   }
  //                   resolve(res)
  //                 }).catch(err => {
  //                   console.log("could not save ext feed", err) 
  //                   reject(err)
  //                 })
  //                 //  res.data
  //                 resolve(res)
  //               }).catch(err => {
  //                 console.log("could not save ext feed", err)
  //                 reject(err)
  //               })
  //               resolve(res1)
  //             }).catch(err => {
  //               console.log("could not save ext feed", err)
  //               reject(err)
  //             })
  //             resolve(res)
  //           }).catch(err => {
  //             console.log("error finding external-feedback data", err);
  //             reject(err)
  //           })
  //           resolve(res)
  //         }).catch(err => {
  //           console.log("error finding external-feedback data", err);
  //           reject(err)
  //         })
  //       }

  //     }
  //     else{
  //       for(let j=0;j<gapFeed.length;j++) {
  //         if(gapFeed[j].currentGap===0){
  //           store.dispatch("external-feedback/find", {
  //             query: {id: gapFeed[j].extId}
  //           }).then(res => {
  //             store.dispatch("external-feedback/find", {
  //               query: {
  //                 endorsementInvitePrgmsId: res.data[0].endorsementInvitePrgmsId,
  //               }
  //             }).then(response => {
  //               let deletedexternalToken = [];
  //               for (var i = 1; i < response.data.length; i++) {
  //                 deletedexternalToken.push(response.data[i].externalToken);
  //               }
  //               store.dispatch("invitee-message-id/find", {
  //                 query: {
  //                   externalToken: deletedexternalToken
  //                 }
  //               }).then(res1 => {
  //                 let gapFeedObj = {};
  //                 if ((response.data.length) === 1) {
  //                   gapFeedObj = {
  //                     currentGap: 0,
  //                     feedbackReceivedDate: new Date(new Date().setDate(new Date().getDate() + 1)),
  //                     externalTokenExpired: 1,
  //                     index: gapFeed[j].index,
  //                     notesDescription:gapFeed[j].notesDescription,
  //                     emailStatus: 4,
  //                     feedbackId: gapFeed[j].extId,
  //                   }
  //                 } else {
  //                   gapFeedObj = {
  //                     currentGap: gapFeed[j].currentGap,
  //                     feedbackReceivedDate: new Date(new Date().setDate(new Date().getDate() + 1)),
  //                     index: gapFeed[j].index,
  //                     notesDescription:gapFeed[j].notesDescription,
  //                     emailStatus: 4,
  //                     externalTokenExpired: 1,
  //                     feedbackId: gapFeed[j].extId,
  //                   }
  //                 }
  //                 store.dispatch("external-feedback/patch", [gapFeed[j].extId, gapFeedObj]).then(res1 => {
  //                   store.dispatch("external-feedback/find", {
  //                     query: {
  //                       endorsementInvitePrgmsId: res1.endorsementInvitePrgmsId,
  //                       currentGap: null
  //                     }
  //                   }).then(res => {
  //                     for (var i = 0; i < res.data.length; i++) {
  //                       //  const date = new Date();
  //                       //  if ((new Date(res.data[i].feedbackSentDate)) >(new Date()) ) {
  //                       let ZeroGapData ={};
  //                       ZeroGapData = {
  //                         currentGap: 0,
  //                         feedbackStatus: i,
  //                         notesDescription:gapFeed[i].notesDescription,
  //                         emailStatus: 5,
  //                         externalTokenExpired: 1,
  //                         feedbackReceivedDate: new Date(new Date().setDate(new Date().getDate() + 2))
  //                       }
  //                       // if( res.data.length<=5) {
  //                       //
  //                       // }
  //                       // else{
  //                       //   ZeroGapData = {
  //                       //     currentGap: 0,
  //                       //     feedbackStatus: i,
  //                       //     emailStatus: 5,
  //                       //     externalTokenExpired: 1,
  //                       //     feedbackReceivedDate: new Date(new Date().setDate(new Date().getDate() + 1))
  //                       //   }
  //                       // }
  //                       store.dispatch("external-feedback/patch", [res.data[i].id, ZeroGapData]).then(res => {
  //                         resolve(res)
  //                       }).catch(err => {
  //                         console.log("could not save ext feed", err)
  //                         reject(err)
  //                       })
  //                       //}
  //                     }
  //                     resolve(res)
  //                   }).catch(err => {
  //                     console.log("could not save ext feed", err)
  //                     reject(err)
  //                   })
  //                   //  res.data
  //                   resolve(res)
  //                 }).catch(err => {
  //                   console.log("could not save ext feed", err)
  //                   reject(err)
  //                 })
  //                 resolve(res1)
  //               }).catch(err => {
  //                 console.log("could not save ext feed", err)
  //                 reject(err)
  //               })
  //               resolve(res)
  //             }).catch(err => {
  //               console.log("error finding external-feedback data", err);
  //               reject(err)
  //             })
  //             resolve(res)
  //           }).catch(err => {
  //             console.log("error finding external-feedback data", err);
  //             reject(err)
  //           })

  //         }
  //         else{
  //           const gapFeedObj = {
  //             currentGap:gapFeed[j].currentGap,
  //             feedbackReceivedDate: new Date(),
  //             externalTokenExpired: 1,
  //             index: gapFeed[j].index,
  //             notesDescription:gapFeed[j].notesDescription,
  //             emailStatus: 4,
  //             feedbackId: gapFeed[j].extId,
  //           }
  //           store.dispatch("external-feedback/patch", [gapFeed[j].extId, gapFeedObj]).then(res => {
  //             resolve(res)
  //           }).catch(err => {
  //             console.log("could not save ext feed", err)
  //             reject(err)
  //           })
  //         }
  //       }
  //     }
  //   })
  // },
saveExternalFeedback({ commit }, gapFeed) {
    return new Promise(async (resolve, reject) => {
      try {
        let promises = [];
        
        for (let j = 0; j < gapFeed.length; j++) {
          const patchData = {
            currentGap: gapFeed[j].currentGap,
            notesDescription: gapFeed[j].notesDescription,
            feedbackReceivedDate: new Date(), // Saved TODAY
            externalTokenExpired: 1,          // Kill this token so it can't be reused
            emailStatus: 1                    // Mark as completed
          };
          
          // Save the advisor's answers to the database
          promises.push(
            store.dispatch("external-feedback/patch", [gapFeed[j].extId, patchData])
          );
        }
        
        const result = await Promise.all(promises);
        resolve(result);
      } catch (err) {
        console.log("Could not save external feedback", err);
        reject(err);
      }
    });
  },
  fetchInvitees({commit}, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("endorsement-invite/find", query).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("error finding invitee data", err)
      })
    })
  },

  removeInvitees({commit}, query){
    return new Promise((resolve, reject) => {
      store.dispatch("endorsement-invite/remove",query).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("error removing invitee data", err)
      })
    })
  },

  fetchInviteePrgms({commit}, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("endorsement-invite-prgms/find", query).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("error finding invitee prgms data", err)
      })
    })
  },

  removeInviteePrgms({commit}, query){
    return new Promise((resolve, reject) => {
      store.dispatch("endorsement-invite-prgms/remove", query).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("error removing invitee prgms data", err)
      })
    })
  },

  fetchFeeddata({commit}, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("external-feedback/find", query).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("error finding feedback data", err)
      })
    })
  },

  patchFeeddata({commit}, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("external-feedback/patch", [query.id,query]).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("error updating feedback data", err)
      })
    })
  },

  removeFeeddata({commit}, query){
    return new Promise((resolve, reject) => {
      store.dispatch("external-feedback/remove", query).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("error removing feedback data", err)
      })
    })
  },

  fetchInviteeMsg({commit},query){
    return new Promise((resolve,reject) => {
      store.dispatch("invitee-message-id/find",query).then(res => {
        resolve(res);
      }).catch(err => {
        console.error("can not found invitee message id");
      })
    })
  },
  removeInviteeMsgId({commit}, query){
    return new Promise((resolve, reject) => {
      store.dispatch("invitee-message-id/remove", query).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("Message invitee data Error Removing", err)
      })
    })
  },
  patchInvitees({commit},query){
    return new Promise((resolve,reject) => {
      store.dispatch("endorsement-invite/patch",[query.id,query]).then(res => {
        resolve('success');
      }).catch(err => {
        resolve('fail');
        console.log("Error removing invitee",err);
      })
    })
  },

  updateChartData({commit}, chartObj) {
    return new Promise((resolve, reject) => {
      commit("UPDATE_CHART_OBJ", chartObj)
    })
  },

  markGoalComplete({commit}, goalCompleteObj) {
    return new Promise((resolve, reject) => {
      store.dispatch("trainee-competencies/patch", [goalCompleteObj.id, goalCompleteObj]).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("error mark goal complete", err)
        reject(err);
      })
    })
  },

  destroyAllState({commit}) {
    return new Promise((resolve, reject) => {
      commit("DESTROY_EMAIL_LIST");
      commit("DESTROY_PROGRESS_MEASURES");
      commit("DESTROY_EXTERNAL_FEEDBACK");
      commit("DESTROY_CHART_OBJ");
    })
  }
};
